import { NextPage } from 'next';

import getAllCities, { ResponseDto as AllCitiesResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-all-cities';

import { IS_PRODUCTION_ENVIROMENT } from '~/src/constants';
import Layout from '~/src/features/_layout';
import SeoLanding from '~/src/features/seoLanding';
import getRequester from '~/src/helpers/getRequester';
import { selectCompanyName } from '~/src/store/selectors/city';

interface ITestGeoIpPage {
    cities: AllCitiesResponseDto | null,
    companyName: string,
}

const SeoLandingPage: NextPage<ITestGeoIpPage> = ({ cities, companyName }) => {
    return (
        <Layout
            title={'Провайдер интернета и ТВ ' + companyName}
            description={`Официальный сайт провайдера ${companyName}. Скоростной интернет,
            цифровое телевидение и онлайн-кинотеатр, домофон и видеонаблюдение. Адреса и телефоны офисов.`}
            withMenu={false}
            withFooter={false}
            withChat={true}
        >
            <SeoLanding cities={cities}/>
        </Layout>
    );
};

SeoLandingPage.getInitialProps = async options => {
    const { store, req } = options;

    const doRequest = getRequester(req);

    const companyName = selectCompanyName(store.getState());

    const response = await doRequest.apiContent<AllCitiesResponseDto>(getAllCities(IS_PRODUCTION_ENVIROMENT ? '0' : '1'));

    return {
        cities: response.isSuccess ? response.payload : null,
        companyName,
    };
};

export default SeoLandingPage;
